import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logowhite from "../images/logowhite.png";
import logoblack from "../images/logoblack.png";

const Header: React.FC = () => {
    const [isScrolled, setIsScrolled] = useState(false)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const location = useLocation()

    const isDarkHeaderPage = location.pathname === '/' || location.pathname === '/services'

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true)
            } else {
                setIsScrolled(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        setIsMobileMenuOpen(false)
    }, [location])

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen)
    }

    const getCurrentLogo = () => {
        if (isScrolled || !isDarkHeaderPage) return logoblack
        return logowhite
    }

    const getNavTextColor = () => {
        if (isScrolled || !isDarkHeaderPage) return 'text-gray-600'
        return 'text-white'
    }

    return (
        <header
            id="main-header"
            className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'header-scrolled bg-white shadow-md' : 'py-6'}`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* 3-Column Grid for Perfect Centering */}
                <div className="grid grid-cols-3 items-center">

                    {/* Left Column: Navigation Links (Desktop) / Mobile Toggle (Mobile) */}
                    <div className="flex items-center">
                        <button
                            className={`md:hidden ${getNavTextColor()} transition-colors`}
                            onClick={toggleMobileMenu}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <nav className="hidden md:flex gap-8 items-center">
                            <Link to="/" className={`nav-link ${getNavTextColor()} hover:text-dark transition-colors`}>Home</Link>
                            <Link to="/about" className={`nav-link ${getNavTextColor()} hover:text-dark transition-colors`}>About</Link>
                            <Link to="/services" className={`nav-link ${getNavTextColor()} hover:text-dark transition-colors`}>Services</Link>
                        </nav>
                    </div>

                    {/* Middle Column: Logo (Exactly Centered) */}
                    <div className="flex justify-center">
                        <Link to="/" id="logo-wrapper" className="flex-shrink-0 flex flex-col items-center">
                            <img
                                src={getCurrentLogo()}
                                alt="Guardrisk Logo"
                                className="h-16 md:h-20 w-auto transition-all"
                            />
                            {isScrolled && (
                                <span className="text-xs text-black-400 tracking-widest uppercase mt-1 font-body">
                                    More than protection
                                </span>
                            )}
                        </Link>
                    </div>

                    {/* Right Column: Remaining Links + Conditional Button */}
                    <div className="flex justify-end items-center gap-8">
                        <nav className="hidden md:flex gap-8 items-center">
                            <Link to="/blog" className={`nav-link ${getNavTextColor()} hover:text-dark transition-colors`}>Blog</Link>
                            <Link to="/contact" className={`nav-link ${getNavTextColor()} hover:text-dark transition-colors`}>Contact</Link>

                            {/* Get Quote Button: Hidden on scroll */}
                            {!isScrolled && (
                                <button className="btn-primary px-6 py-2 rounded font-body font-medium whitespace-nowrap">
                                    Get Quote
                                </button>
                            )}
                        </nav>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white border-t">
                    <nav className="flex flex-col gap-4 p-4">
                        <Link to="/" className="text-gray-body hover:text-dark">Home</Link>
                        <Link to="/about" className="text-gray-body hover:text-dark">About</Link>
                        <Link to="/services" className="text-gray-body hover:text-dark">Services</Link>
                        <Link to="/blog" className="text-gray-body hover:text-dark">Blog</Link>
                        <Link to="/contact" className="text-gray-body hover:text-dark">Contact</Link>

                        {/* Mobile Button: Also respects the scroll rule if header is visible */}
                        {!isScrolled && (
                            <button className="btn-primary px-6 py-2 rounded font-body font-medium w-full">
                                Get Quote
                            </button>
                        )}
                    </nav>
                </div>
            )}
        </header>
    )
}

export default Header